var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomaccordionDrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 12,
    viewBox: "0 0 19 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.27289 11.3333C9.03908 11.3346 8.80731 11.2898 8.59086 11.2014C8.3744 11.113 8.17753 10.9827 8.01153 10.8181L0.905285 3.71181C0.739641 3.54617 0.608245 3.34952 0.518599 3.1331C0.428953 2.91667 0.382813 2.68471 0.382813 2.45046C0.382812 2.2162 0.428953 1.98424 0.518599 1.76781C0.608245 1.55139 0.739641 1.35474 0.905285 1.1891C1.07093 1.02345 1.26758 0.892057 1.484 0.802411C1.70043 0.712765 1.93239 0.666626 2.16664 0.666626C2.4009 0.666626 2.63286 0.712765 2.84929 0.802411C3.06571 0.892057 3.26236 1.02345 3.428 1.1891L9.27289 7.06952L15.1355 1.42005C15.299 1.23833 15.4981 1.09228 15.7206 0.991038C15.943 0.889799 16.184 0.835547 16.4284 0.831676C16.6727 0.827804 16.9153 0.874395 17.1408 0.968537C17.3664 1.06268 17.57 1.20235 17.7391 1.3788C17.9083 1.55526 18.0391 1.76471 18.1236 1.99405C18.2081 2.22339 18.2443 2.4677 18.23 2.71169C18.2158 2.95567 18.1513 3.19409 18.0407 3.41203C17.9301 3.62997 17.7757 3.82275 17.5872 3.9783L10.481 10.8358C10.1561 11.1491 9.72414 11.3269 9.27289 11.3333Z",
    fill: "#14B082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomaccordionDrop);
export default __webpack_public_path__ + "static/media/customaccordion-drop.4a157c0b5a4710fa527c5039dea08a59.svg";
export { ForwardRef as ReactComponent };